<template>
    <v-main style="padding: 0px">
        <Home id="home"/>
        <About id="about"/>
        <v-parallax height="300" :src="require('@/assets/background/MIddle.png')"></v-parallax>
        <Lawyer id="lawyer"/>
        <v-parallax height="300" :src="require('@/assets/background/Bottom.png')"></v-parallax>
    </v-main>
</template>

<script>
    import Home from '../components/Home';
    import About from '../components/About'
    import Lawyer from "../components/Lawyer";

    export default {
        name: 'App',
        components: {
            Lawyer,
            Home,
            About,
        },
        data: () => ({
        }),
    };
</script>
